export function createAudioRequestOwnership() {
  let generation = 0;
  let activeController = null;

  function begin() {
    activeController?.abort();
    const controller = new AbortController();
    const requestGeneration = ++generation;
    activeController = controller;

    return {
      signal: controller.signal,
      isCurrent() {
        return (
          generation === requestGeneration &&
          activeController === controller &&
          !controller.signal.aborted
        );
      },
      finish() {
        if (generation === requestGeneration && activeController === controller) {
          activeController = null;
        }
      },
    };
  }

  function cancel() {
    generation += 1;
    activeController?.abort();
    activeController = null;
  }

  return { begin, cancel };
}
